var map = {
  "./da.json": [
    "45784",
    [
      43585
    ]
  ],
  "./fi.json": [
    "64938",
    [
      81463
    ]
  ],
  "./sv.json": [
    "714",
    [
      57527
    ]
  ],
  "./ja.json": [
    "38286",
    [
      44067
    ]
  ],
  "./lt.json": [
    "85103",
    [
      81924
    ]
  ],
  "./sl.json": [
    "83472",
    [
      87817
    ]
  ],
  "./fr.json": [
    "40883",
    [
      51696
    ]
  ],
  "./es.json": [
    "10215",
    [
      10764
    ]
  ],
  "./no.json": [
    "3740",
    [
      44045
    ]
  ],
  "./cs.json": [
    "75217",
    [
      17034
    ]
  ],
  "./en.json": [
    "32880",
    [
      62505
    ]
  ],
  "./description/en.json": [
    "49391",
    [
      964
    ]
  ],
  "./pl.json": [
    "65323",
    [
      82808
    ]
  ],
  "./hu.json": [
    "98344",
    [
      44305
    ]
  ],
  "./nl.json": [
    "45641",
    [
      76402
    ]
  ],
  "./de.json": [
    "81492",
    [
      24533
    ]
  ],
  "./pt.json": [
    "99043",
    [
      43744
    ]
  ],
  "./it.json": [
    "27950",
    [
      37891
    ]
  ],
  "./et.json": [
    "48170",
    [
      63063
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 69650;
module.exports = __rspack_async_context;
